import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FormField } from "@/components/FormBits";
import { api, formatError } from "@/lib/api";

export function ResellerFormDialog({ kind, cfg, reseller, onClose, onSaved }) {
  const { tid } = cfg;
  const editing = !!reseller.user_id;
  const [f, setF] = useState({ name: reseller.name || "", email: reseller.email || "", phone: reseller.phone || "", document: reseller.document || "", password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const payload = { name: f.name, phone: f.phone, document: f.document, password: f.password || null };
    try {
      if (editing) await api.patch(`/admin/${kind}/${reseller.user_id}`, payload);
      else await api.post(`/admin/${kind}`, { ...payload, email: f.email });
      toast.success(editing ? cfg.updated : cfg.created);
      onSaved();
    } catch (err) {
      toast.error(formatError(err));
      setBusy(false);
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-lg" data-testid={`${tid}-form-dialog`}>
        <DialogHeader><DialogTitle>{editing ? cfg.editTitle : cfg.newLabel}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid gap-4 sm:grid-cols-2">
          <FormField id={`${tid}-name`} label="Nome / empresa" required value={f.name} onChange={set("name")} className="sm:col-span-2" />
          <FormField id={`${tid}-email`} label="E-mail de acesso" type="email" required disabled={editing} value={f.email} onChange={set("email")} className="sm:col-span-2" />
          <FormField id={`${tid}-phone`} label="Telefone / WhatsApp" value={f.phone} onChange={set("phone")} />
          <FormField id={`${tid}-document`} label="CPF / CNPJ" value={f.document} onChange={set("document")} />
          <FormField id={`${tid}-password`} label={editing ? "Nova senha (deixe vazio para manter)" : "Senha de acesso (mín. 8)"} type="password"
            minLength={8} required={!editing && !reseller.allowNoPassword} value={f.password} onChange={set("password")} className="sm:col-span-2" />
          <p className="text-xs text-slate-500 sm:col-span-2">{cfg.convertHint}</p>
          <div className="flex justify-end gap-2 sm:col-span-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid={`btn-cancel-${tid}`}>Cancelar</Button>
            <Button type="submit" disabled={busy} className="bg-[#0099DD] hover:bg-sky-700" data-testid={`btn-save-${tid}`}>{busy ? "Salvando..." : "Salvar"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
